{
  "column": {
    "active": "Aktiv",
    "company": "Firma",
    "createdAt": "Erstellt am",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "name": "Name",
    "roles": "Rollen",
    "salutation": "Anrede",
    "title": "Titel"
  },
  "label": {
    "addUser": "Benutzer hinzufügen",
    "cancel": "Abbrechen",
    "clearFilter": "Filter zurücksetzen",
    "delete": "Löschen",
    "errorDeleting": "Beim Löschen ist ein Fehler aufgetreten.",
    "errorHeader": "Fehler",
    "invalidData": "Ungültige Daten",
    "onboardingMailError": "Beim Senden der Onboarding-Mail ist ein Fehler aufgetreten.",
    "onboardingMailSent": "Die Onboarding-Mail wurde erfolgreich gesendet.",
    "save": "Speichern",
    "sendOnboardingMail": "Onboarding-Mail senden",
    "successHeader": "Erfolg",
    "successfullyDeleted": "Der Eintrag wurde erfolgreich gelöscht.",
    "successfullyDeletedHeader": "Erfolgreich gelöscht"
  },
  "message": {
    "noUserData": "Keine Benutzerdaten vorhanden."
  },
  "placeholder": {
    "search": "Suchen",
    "selectAll": "Alle auswählen",
    "selectRole": "Rolle auswählen"
  },
  "user": {
    "create": "Benutzer erstellen",
    "createFailed": "Benutzer konnte nicht erstellt werden.",
    "created": "Benutzer erfolgreich erstellt.",
    "deleteConfirmMessage": "Möchten Sie diesen Benutzer wirklich löschen?",
    "deleteHeader": "Benutzer löschen",
    "edit": "Benutzer bearbeiten",
    "updateFailed": "Benutzer konnte nicht aktualisiert werden.",
    "updated": "Benutzer erfolgreich aktualisiert."
  }
}